import React from 'react';
import { useSpringBigStore, useTheme } from '@springbig/shared';
import { VStack } from 'native-base';
import { Caption, H4 } from '~/shared/Typography';
import { format } from 'date-fns';

const TransactionHeader = () => {

    const {
        button_primary,
        button_text,
        radius_md,
    } = useTheme();

    const { member, merchant } = useSpringBigStore();

    return (
        <VStack
            bg={button_primary}
            borderBottomRadius={radius_md}
            space={2}
            p={4}
        >
            { member?.first_name && member?.last_name &&
                <Caption
                    color={button_text}
                    text={'giftCard.transactions.greeting'}
                    textValues={[`${member?.first_name} ${member?.last_name}`]}
                />
            }
            <H4
                text={'giftCard.transactions.title'}
                textValues={[merchant?.gift_card_alias]}
                color={button_text}
                textAlign={'center'}
                fontSize={20}
            />
            <Caption
                color={button_text}
                text={'giftCard.transactions.lastUpdated'}
                textValues={[format(new Date(), 'MM-dd-yyyy')]}
                textAlign={'center'}
                fontSize={10}
            />
        </VStack>
    );
};

export default TransactionHeader;
